var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("p", { staticClass: "details__shipping" }, [
    _c("span", {
      class:
        "details__availability details__availability--" + _vm.availability.id
    }),
    _vm._v(" "),
    _c("span", [_vm._v("\n        " + _vm._s(_vm.name) + "\n    ")])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }